import { authedFetch } from '@/lib/authed-fetch';
import { supabase } from '@sixam/supabase/client';

const acceptedThisSession = new Set<string>();

export function acceptedCurrentTermsThisSession(userId: string): boolean {
  return acceptedThisSession.has(userId);
}

/**
 * Records that the signed-in member agreed to the current terms.
 *
 * Written through the API rather than the client so the timestamp and version
 * come from the server — a self-reported acceptance date is not evidence of
 * anything.
 */
export async function recordTermsAcceptance(): Promise<void> {
  const response = await authedFetch('/api/terms/accept', { method: 'POST' });
  if (!response.ok) {
    const payload = (await response.json().catch(() => null)) as { error?: string } | null;
    throw new Error(payload?.error ?? 'Could not record terms acceptance.');
  }

  const {
    data: { session },
  } = await supabase.auth.getSession();
  if (session) {
    acceptedThisSession.add(session.user.id);
  }
}
